import API from '../../sunwiseAPI';
const ENTITY = 'aftersales-printed';

export const getReportEnded = (id) => API.get(`/api/v1/${ENTITY}/${id}/sunpay`);

export const updateReportEnded = (id, data) =>
    API.put(`/api/v1/${ENTITY}/${id}/sunpay`, data);
